import { useEffect, useState } from "react";

import { fetchSubjects } from "./metadata";

type UseSubjectsOptions = {
  limit?: number;
  page?: number;
};

export function useSubjects(options?: UseSubjectsOptions) {
  const [data, setData] = useState<string[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const limit = options?.limit ?? 200;
  const page = options?.page ?? 1;

  useEffect(() => {
    let isMounted = true;

    fetchSubjects(limit, page)
      .then((subjects) => {
        if (!isMounted) return;
        setData(subjects);
        setError(null);
      })
      .catch(() => {
        if (!isMounted) return;
        setError("Impossible de charger les matières.");
      })
      .finally(() => {
        if (!isMounted) return;
        setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [limit, page]);

  return { data, loading, error };
}
